import {MULTI_SYNTH} from 'constants/instrument-types.js';

export const findParameterWithContext = (
    {context, name, id},
    track,
    sequencerEngine
) => {
    let tracks = sequencerEngine ? sequencerEngine.subSequences.flatMap( x => x.tracks) : [];
    if (!context) {
        return undefined;
    }
    if (name === 'BPM') {
        return sequencerEngine.bpmParameter;
    }
    if (context.instrumentType === MULTI_SYNTH) {
        // then we need to find a synth in the track 

        let trackFound = undefined;
        if (track.instrument && track.instrument.getInstrumentType() === MULTI_SYNTH) {
            trackFound = track;
        } else {
            trackFound = tracks.find(
                t => t.instrument && t.instrument === MULTI_SYNTH && !t.isFrozens);
        }

        if (!trackFound) {
            return undefined;
        }

        // otherwise lets look at the subdevices
        let subDevice = trackFound.instrument.getSubDevice(context.subDevice);

        if (subDevice) {
            let parameters = subDevice.getParameters ? subDevice.getParameters() : subDevice.parameters;
            let parameter = parameters.find(p => p.name === name);
            // if its a formant then we need to get enable it

            if (parameter && parameter.context && parameter.context.formant) {
                let formant = parameter.context.formant;
                if (!formant.enabledParameter.get()) {
                    // then enable the formant
                    formant.enabledParameter.set(true, true, true);
                }
            }
            return parameter;
        }
        return undefined;
    }

    // otherwise lets check for effects/midi effects
    if (context.effect !== undefined) {
        // find an effect with that name
        // first in this track
        // then in some other track

        for (let track of tracks) {
            let effects = [... track.effects, ...track.midiEffects.effects, ...track.liveEffects.effects];
            let effectFound = effects.find(e => e.name === context.effectName);
            if (effectFound) {
                let param = effectFound.getParameters().find(
                    p => p.name === name);
                return param;
            }
        }

        // check all the sub sequence shit
        for (let subSequence of track.sequencerEngine.subSequences) {
            let effects = [... subSequence.midiEffects.effects, subSequence.playhead];
            let effectFound = effects.find(e => e.name === context.effectName);
            if (effectFound) {
                let param = effectFound.getParameters().find(
                    p => p.name === name);
                return param;
            }
        }
    }

    return undefined;
};

